import useDoExerciseStore from "../../store/exerciseStore"

export const Writing = ({onChange}) => {
  const {  isLoading } = useDoExerciseStore()

  return (
    <div className="relative size-max w-full">
               <textarea onChange={(e) => onChange(e.target.value)}
               className="border *:border-gray-300 w-full py-8 px-4 h-64 rounded-lg">

                </textarea>

               {isLoading &&
                <div className="absolute bottom-4 right-4 text-primary font-black animate-bounce">
                AI đang chấm điểm...
              </div>
              }
            </div>
  )
}
